import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { bounceIn } from "src/app/animations/custom.animation";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";

@Component({
  selector: "app-game-blog",
  templateUrl: "./game-blog.component.html",
  styleUrls: ["./game-blog.component.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [IonicModule, InProgressAnimationComponent],
})
export class GameBlogComponent implements OnInit {
  selectedSlide: any;
  userId: string;

  constructor(private location: Location, private analytics: AngularFireAnalytics, private authService: AuthService) {
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("GameBlogComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("game_blog_details", {
          userId: this.userId
        });
      })
      .catch((error) => {
        return error;
      });
  }

  goBack() {
    this.location.back();
  }
}
